module.exports = __webpack_public_path__ + "img/04.dd95f5f9.png";